import React from 'react'

import { systemMatchesAllFilters } from '../helpers/systems'
import { useFiltersStore } from '../state/filtersStore'
import { T_Tab, useNavigationStore } from '../state/navigationStore'
import { useWpDataStore } from '../state/wpDataStore'
import { SystemTabIcon } from './Svg'

const TabList = () => {
  const navigateTab = useNavigationStore((state) => state.navigateTab)
  const currentTab = useNavigationStore((state) => state.tab)

  const appliedFilters = useFiltersStore((state) => state.appliedFilters)
  const systemFilters = appliedFilters.filter((f) => f.applies_to === 'systems')

  const { systems } = useWpDataStore()

  // Systems that matches all applied filters = shortlist
  const filteredSystems =
    systems?.filter((system) =>
      systemMatchesAllFilters(system, systemFilters)
    ) ?? []

  const cls = (tab: T_Tab) => {
    return [
      'tab-list__button',
      currentTab === tab && 'tab-list__button--active',
    ].join(' ')
  }
  return (
    <div className='tab-list'>
      {/* <button
        className={cls('shortlist')}
        onClick={() => navigateTab('shortlist')}
      >
        <i className='fa-solid fa-stars'></i>
        <span>Shortlist</span>
      </button> */}
      <button className={cls('systems')} onClick={() => navigateTab('systems')}>
        <SystemTabIcon />
        <span>Systems</span>
        {systemFilters && systemFilters.length > 0 && (
          <span className='tab-list__count'>{filteredSystems.length}</span>
        )}
      </button>
      <button className={cls('cases')} onClick={() => navigateTab('cases')}>
        <i className='fa-solid fa-file-lines'></i>
        <span>Cases</span>
      </button>
    </div>
  )
}

export { TabList }
